import React, { ReactElement, ReactNode, createContext } from "react"

import { LCTOnlyDatasets } from "../../../../../../constants/enums"
import { AppError } from "../../../../../../errors/errorProcessors"
import { IDeviceFormContextValue } from "../../../../types/providerTypes"
import CreateHpDeviceProvider from "../../../hp/providers/baseProviders/createHpDeviceProvider"
import { HpDeviceFormData } from "../../../types/providerTypes"

type CreateEbDeviceProviderProps = {
    formData: HpDeviceFormData
    setFormData: React.Dispatch<React.SetStateAction<HpDeviceFormData>>
    formDataIsLoading: boolean
    formDataError?: AppError
    systemReference?: string
    attachmentUUID?: string
    canEditManufacturer: boolean
    children: ReactNode
}

export const CreateEbDeviceContext = createContext(
    {} as IDeviceFormContextValue<HpDeviceFormData>
)

/**
 * Thin wrapper around CreateHpDeviceProvider — delegates all logic,
 * only overrides the dataset (EB) and context.
 */
const CreateEbDeviceProvider = ({
    formData,
    setFormData,
    formDataIsLoading,
    formDataError,
    systemReference,
    attachmentUUID,
    canEditManufacturer,
    children,
}: CreateEbDeviceProviderProps): ReactElement => (
    <CreateHpDeviceProvider
        formData={formData}
        setFormData={setFormData}
        formDataIsLoading={formDataIsLoading}
        formDataError={formDataError}
        systemReference={systemReference}
        attachmentUUID={attachmentUUID}
        canEditManufacturer={canEditManufacturer}
        dataset={LCTOnlyDatasets.EB}
        deviceContext={CreateEbDeviceContext}
    >
        {children}
    </CreateHpDeviceProvider>
)

CreateEbDeviceProvider.defaultProps = {
    formDataError: undefined,
    attachmentUUID: undefined,
    systemReference: undefined,
}

export default CreateEbDeviceProvider
